<template>
  <div>
    <div class="float-center mt-2 mb-2 table-title">
      <strong>
        {{
          $getVisibleNames(
            "teaching.duocsapmatter",
            true,
            "Asignaturas creadas en SAP"
          ).toUpperCase()
        }}
      </strong>
    </div>
    <div
      class="d-flex"
      v-if="
        [
          'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
          'DIRECTIVOS ACADÉMICOS (CAMPUS)',
        ].some((group) => user.group_names.includes(group)) || user.is_superuser
      "
    >
      <b-button
        v-if="allows_crud"
        class="ml-3 mr-auto"
        size="sm"
        @click="$bvModal.show(`upload-excel-matter-sap-modal`)"
      >
        {{
          $t("curricularProducts.matterList.updateExcel", {
            entity: $getVisibleNames(
              "teaching.duocsapmatter",
              true,
              "Asignaturas creadas en SAP"
            ),
          })
        }}
      </b-button>
    </div>
    <div>
      <NewGenericBTable
        :key="key_duoc_sap_matter_list"
        :fields="fields"
        :pre_current_page="current_page"
        :pre_multiple_search="current_tag"
        :url="'/integrations/duoc-sap-matter/'"
        @current_page="currentPage"
        @current_tag="currentTag"
      >
        <template v-if="allows_crud" #cell(actions)="row">
          <ButtonSmall
            :click_button="() => deletedDuocSapMatter(row.item.id)"
            :tooltip_text="
              $t('reusable.common.deleteTooltip', {
                entity: $getVisibleNames(
                  'teaching.duocsapmatter',
                  false,
                  'Asignatura creada en SAP'
                ),
              })
            "
            :icon="'trash'"
          ></ButtonSmall>
          <!-- <button-delete
            @click="deletedDuocSapMatter(row.item.id)"
            v-b-tooltip.v-secondary.noninteractive="
              'Eliminar la ' +
              $getVisibleNames(
                'teaching.duocsapmatter',
                false,
                'Asignatura creada en SAP'
              )
            "
          ></button-delete> -->
        </template>
      </NewGenericBTable>
    </div>
    <b-modal
      :id="`upload-excel-matter-sap-modal`"
      :title="
        $t('curricularProducts.matterList.updateExcel', {
          entity: $getVisibleNames(
            'teaching.duocsapmatter',
            true,
            'Asignaturas creadas en SAP'
          ),
        })
      "
      size="md"
      hide-footer
    >
      <FileSelector
        :post_file="false"
        :restrict_file_weight="false"
        @file="uploadFile"
      ></FileSelector>
    </b-modal>
  </div>
</template>

<script>
// import * as names from "@/store/names";
import { mapGetters } from "vuex";
export default {
  name: "DuocSapMatterList",
  components: {
    NewGenericBTable: () => import("@/components/reusable/NewGenericBTable"),
    FileSelector: () => import("@/components/reusable/FileSelector"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
  },
  props: {
    allows_crud: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      key_duoc_sap_matter_list: 0,
      current_page: 1,
      current_tag: [],
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    fields() {
      return [
        {
          key: "begda",
          label: "begda",
          //   sortable: true,
          display_column: true,
        },
        {
          key: "endda",
          label: "endda",
          //   sortable: true,
          display_column: true,
        },
        {
          key: "otjid",
          label: "otjid",
          //   sortable: true,
          display_column: true,
        },
        {
          key: "aedtm",
          label: "aedtm",
          //   sortable: true,
          display_column: true,
        },
        {
          key: "uname",
          label: "uname",
          //   sortable: true,
          display_column: true,
        },
        {
          key: "sigla",
          label: "sigla",
          //   sortable: true,
          display_column: true,
        },
        {
          key: "nombre",
          label: "nombre",
          //   sortable: true,
          display_column: true,
        },
        {
          key: "mc_seark",
          label: "mc_seark",
          //   sortable: true,
          display_column: true,
        },
        {
          key: "actions",
          label: "",
          display_column: true,
        },
      ];
    },
  },
  methods: {
    currentPage(current_page) {
      this.current_page = current_page;
    },
    currentTag(current_tag) {
      this.current_tag = current_tag;
    },
    deletedDuocSapMatter(id) {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "teaching.duocsapmatter",
            true,
            "Asignaturas creadas en SAP"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$restful
            .Delete(`/integrations/duoc-sap-matter/${id}/`)
            .then(() => {
              this.key_duoc_sap_matter_list++;
            });
        }
      });
    },
    uploadFile(file) {
      this.$swal.fire({
        title: this.$t("curricularProducts.matterList.uploading"),
        text: this.$t("curricularProducts.matterList.pleaseWaitUpload"),
        allowOutsideClick: false,
        onBeforeOpen: () => {
          this.$swal.showLoading();
        },
      });
      this.$restful
        .Post(`/integrations/update_duoc_sap_matters/`, file)
        .then(() => {
          this.$swal.close();
          this.$swal.fire(
            this.$t("reusable.common.success"),
            this.$t("curricularProducts.matterList.fileUploadedSuccessfully"),
            "success"
          );
          this.key_duoc_sap_matter_list++;
        })
        .catch((error) => {
          this.$swal.close();
          this.$swal.fire(
            this.$t("reusable.common.error"),
            this.$t("curricularProducts.matterList.problemUploadingFile"),
            "error"
          );
          if (error.response && error.response.status === 404) {
            this.$swal.showValidationMessage(`Request failed: ${error}`);
          } else if (
            error.response &&
            error.response.status !== 404 &&
            error.response.data &&
            error.response.data.error
          ) {
            this.$swal.showValidationMessage(`${error.response.data.error}`);
          }
        });
      this.$bvModal.hide(`upload-excel-matter-sap-modal`);
    },
  },
  created() {},
};
</script>

<style scoped>
</style>

